module.exports = __webpack_public_path__ + "static/media/md-code-download.5845b2cd.svg";